module.exports = __webpack_public_path__ + "static/media/SmartShop_8-320w.e4c81639.png";